import React from "react";
import { Alert, AlertTitle, Box, Snackbar, Typography, } from '@mui/material';
import { useAppDispatch, useAppSelector } from "../redux/store";
import { snackActions, selectSnacks } from "../redux/slices/snackSlice/snack";

export default function SnackNotifications() {
  const dispatch = useAppDispatch();
  const snacks = useAppSelector(selectSnacks);
  const onClose = () => dispatch(snackActions.clearSnacks());

  return (
    <>
      {snacks.map((snack, index) => (
        <Snackbar
          key={index}
          open={true}
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
          autoHideDuration={6000}
          message={snack.name}
          onClose={onClose}
        >
          <Alert severity={snack.severity}>
            <AlertTitle>{snack.name}</AlertTitle>
            <Box>
              <Typography>{snack.message}</Typography>
            </Box>
          </Alert>
        </Snackbar>
      ))}
    </>
  );
}
